import { memo, forwardRef, useImperativeHandle } from 'react';
import WarningModal from './warning-modal';
import QaInitOverlay from './qa-init-overlay';
import NavgationBar from './navigation-bar';
import DialogueArea from './dialogue-area';
import DialogueTool from './dialogue-tool';
import EvaluateModal from './evalute-modal';
import FeedbackModal from './feedback-modal';
import DrawerToast from '@/sub-luca-plugin/components/drawer-toast';
import { transformValueToNumberOrBooleanOfObj } from '@/sub-luca-plugin/utils';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { getQaStore } from '@/sub-luca-plugin/store/qa';
import { searchQuestionByOcr } from './helper';

const QuestionAnswerRender = (_: any, ref: any) => {
    const reset = () => {
        eventBusExample.publish('NavgationBar', { type: 'reset' });
        eventBusExample.publish('DialogueArea', { type: 'reset' });
        eventBusExample.publish('QaInitOverlay', { type: 'reset' });
        eventBusExample.publish('DialogueTool', { type: 'reset' });
        eventBusExample.publish('QaToast', { type: 'reset' });
        getQaStore()!.interruptAllExcute('send_cancel');
        getQaStore()!.clearQaStore();
    };

    const init = (params: Record<string, any>) => {
        const newParams = transformValueToNumberOrBooleanOfObj(params, [
            'askId',
            'lucaId',
            'projectId',
            'subjectId',
            'twoLevelSubjectId',
            'courseType',
            'courseId',
            'sceneSource',
            'csItemId',
            'resourceId',
            'resourceType',
            'allowChangeDeterminedIds',
            'showCreateNewQaBtn',
        ]);
        // console.log('init', newParams);
        const {
            lucaAskChatId,
            askId,
            lucaId,
            projectId,
            subjectId,
            twoLevelSubjectId,
            clientSource,
            entrySource,
            courseType,
            courseId,
            sceneSource,
            csItemId,
            resourceId,
            resourceType,
            scense,
            cropUrl,
            allowChangeDeterminedIds = false,
            showCreateNewQaBtn = true,
        } = newParams;
        const defaultIds = [projectId, subjectId, twoLevelSubjectId].filter(item => !!item);
        getQaStore()?.updateInitConfig(
            {
                // init参数作为初始化答疑组件的数据，点击新建问题时需使用本参数
                initResourceType: resourceType,
                initResourceId: resourceId,
                initCourseId: courseId,
                initProjectId: projectId,
                initSubjectId: subjectId,
                initTwoLevelSubjectId: twoLevelSubjectId,
                resourceType,
                resourceId,
                courseType,
                courseId,
                sourceMark: 'gaodun',
                clientSource: clientSource || 'gaodun-pc',
                entrySource,
                showCreateNewQaBtn,
                sceneSource,
                csItemId,
                lucaId,
                // 非学习空间场景下，外部传入的项目、一级科目、二级科目不可反选到哪一级
                disabledInitReverseSelectLevel: [undefined, 0, 8].includes(sceneSource) ? undefined : defaultIds.length,
            },
            true
        );
        // 优先级 lucaAskChatId（“新的”历史答疑）>  askId（“老的”历史答疑）> resourceId（通过资源id查询用户最近的答疑记录） > lucaId（创建“新的”答疑）
        if (lucaAskChatId) {
            eventBusExample.publish('QaInitOverlay', { type: 'initByLucaAskChatId', params: { lucaAskChatId } });
        } else if (askId) {
            eventBusExample.publish('QaInitOverlay', { type: 'initByAskId', params: { askId } });
        } else if (resourceId) {
            eventBusExample.publish('QaInitOverlay', {
                type: 'initByResourceId',
                params: { lucaId, resourceType, resourceId, defaultIds },
            });
        } else if (lucaId) {
            switch (scense) {
                // PC首页的OCR流程
                case 'home_ocr':
                    eventBusExample.publish('CombinePicturesDrawer', {
                        type: 'crop_success',
                        params: { url: cropUrl, lucaId, defaultIds },
                    });
                    break;
                // 小程序的OCR流程
                case 'weapp_ocr':
                    eventBusExample.publish('QaInitOverlay', {
                        type: 'initByLucaId',
                        params: { lucaId, defaultIds, allowChangeDeterminedIds: true },
                        callbacks: {
                            // 开始合并搜索
                            startCombineSearch: async (aiAskOnOff: boolean) => {
                                if (aiAskOnOff) {
                                    await searchQuestionByOcr({ ocrUrl: cropUrl });
                                } else {
                                    eventBusExample.publish('DialogueTool', { type: 'echo', params: { images: [cropUrl] } });
                                }
                            },
                        },
                    });
                    break;
                default:
                    eventBusExample.publish('QaInitOverlay', {
                        type: 'initByLucaId',
                        params: { lucaId, defaultIds, allowChangeDeterminedIds },
                    });
                    break;
            }
        }
    };

    useImperativeHandle(
        ref,
        () => ({
            init,
            reset,
        }),
        []
    );

    return (
        <>
            <NavgationBar />
            <DialogueArea />
            <DialogueTool />
            <QaInitOverlay />
            <WarningModal />
            <EvaluateModal />
            <FeedbackModal />
            <DrawerToast subscribeName="QaToast" />
            <DrawerToast subscribeName="QaDetailToast" />
        </>
    );
};

export default memo(forwardRef(QuestionAnswerRender));
